import { ButtonPropertiesType } from "@website/ui-old/button/button.types";
import pick from "lodash-es/pick";

/**
 * @deprecated please use @website/ui instead
 */
export const useButton = (properties: ButtonPropertiesType) => {
  const { disabled, loading, datatestid } = properties;

  return {
    buttonProps: {
      ...pick(properties, "aria-label", "type", "onClick", "id"),
      disabled: disabled || loading,
      role: "button",
      "data-testid": datatestid
    },
    linkProps: {
      href: "",
      ...pick(properties, "aria-label", "href", "rel", "target", "id"),
      prefetch: false,
      disabled: disabled || loading,
      role: "link",
      "data-testid": datatestid
    }
  };
};
